import { DataColumn, BlankColumn, DataRenderer } from "./types";

//type guarding here.. if the label property exists on a SchemaColumn, then it must be a DataColumn
export const isDataColumn = <T>(column: DataColumn<T> | BlankColumn<T>): column is DataColumn<T> =>
  (column as DataColumn<T>).label !== undefined;

export type SortOpts<T> = { sortVal: keyof T | DataRenderer<T>; descending: boolean; label?: string };
